import { z } from 'zod';
/**
 * La regla de correo del POS: `algo@algo.algo`, sin espacios y con una sola
 * arroba (DecoraPOS, `packages/domain/src/facturacion/facturacion.ts:5`).
 *
 * ## Por que no es `z.string().email()`
 *
 * Los correos a los que se envia un DTE los valida el POS con ESTA regla antes
 * de cobrar. `z.email()` es mas estricta: rechaza `a..b@x.cl`, `ana.@x.cl` o un
 * acento en la parte local, que el POS acepta. Si el borde usara la nuestra, una
 * venta ya cobrada caeria con un 400 por un correo que la pantalla del POS dio
 * por bueno, y la vendedora no tendria como corregirlo. Quien recibe el correo
 * (el facturador) es quien decide si lo puede usar; aca solo se exige la forma.
 */
export const LENIENT_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Correo con la regla del POS. 254 es el maximo de una direccion (RFC 5321). */
export const lenientEmailSchema = z
    .string()
    .trim()
    .max(254, 'El correo no puede superar 254 caracteres.')
    .regex(LENIENT_EMAIL_PATTERN, 'El correo no tiene la forma nombre@dominio.tld.');
//# sourceMappingURL=email.js.map